import { FC, ReactNode, useMemo } from 'react'

import { Link } from '@mui/material'

import { GRTooltip } from '../../../../../components/GRTooltip/GRTooltip'
import { Magnify } from '../../../../../components/Magnify/Magnify'
import { Game } from '../../../../../features/game/types/Game'
import { getGameReviewEditPath } from '../../helpers/reviewHelpers'
import { useReviewTooltip } from '../../hooks/useReviewTooltip'
import { ReviewStatus } from '../../types/ReviewStatus'
import { ReviewStatusIcon } from '../ReviewStatusIcon/ReviewStatusIcon'

type ReviewStatusIndicatorProps = {
  game: Game
  children?: ReactNode
}

export const ReviewStatusIndicator: FC<ReviewStatusIndicatorProps> = ({ game, children }) => {
  const status = useMemo(() => {
    if (!game.reviewId) {
      return ReviewStatus.Empty
    } else if (game.reviewPublished) {
      return ReviewStatus.Published
    } else {
      return ReviewStatus.Draft
    }
  }, [game.reviewId, game.reviewPublished])

  const tooltip = useReviewTooltip(status)

  return (
    <GRTooltip content={tooltip}>
      <ReviewLink appId={game.appId} reviewId={game.reviewId}>
        <Magnify force>
          <ReviewStatusIcon status={status} />
        </Magnify>
      </ReviewLink>
    </GRTooltip>
  )
}

const ReviewLink: FC<{ appId: number; reviewId?: string; children?: ReactNode }> = ({ appId, reviewId, children }) => (
  <Link href={getGameReviewEditPath(appId, reviewId)} target="_blank" rel="noopener noreferrer">
    {children}
  </Link>
)
